import { evaluateBinding } from './dependencies'
import { formatLibraryValue } from './library-values'
import { normalizeStyles } from './styles'
import { getValue } from '../ducks/formInputs'
import { deepSet } from './objects'

export function solveBindings(app, object, context) {
  const { getBinding, getAssetURL, getImageUploadsBaseURL, state } = context

  const formatOpts = {
    getAssetURL,
    getImageUploadsBaseURL,
    branding: app && app.branding,
  }

  const { libraryName, componentName } = object.attributes

  const manifest =
    app.libraryComponentManifests?.[libraryName]?.[componentName] ||
    object.libraryComponentManifest

  if (!manifest) {
    return {}
  }

  const values = object.attributes
  const allGlobals = (app && app.libraryGlobals) || {}

  const libraryGlobals =
    (allGlobals[libraryName] && allGlobals[libraryName][componentName]) || {}

  let result = {}

  let childComponents = manifest.childComponents || []
  let normalChildComponents = []
  let references = {}
  let normalProps = []
  let referenceProps = {}

  childComponents.forEach(child => {
    if (child.role === 'listItem' && child.reference) {
      references[child.reference] = references[child.reference] || []
      references[child.reference].push(child)
    } else {
      normalChildComponents.push(child)
    }
  })

  manifest.props.forEach(prop => {
    if (prop.role === 'listItem' && prop.reference) {
      referenceProps[prop.reference] = referenceProps[prop.reference] || []
      referenceProps[prop.reference].push(prop)
    } else {
      normalProps.push(prop)
    }
  })

  const bindingValues = {}

  normalProps.forEach(prop => {
    let value = prop.global ? libraryGlobals[prop.name] : values[prop.name]

    let formattedValue

    if (value) {
      let val = evaluateBinding(state, value, {
        ...context,
        listItemId: values.listItemId,
      })

      if (!val && val !== 0 && val !== false && val !== '') {
        if (
          value.type === 'imageBinding' &&
          value.options &&
          value.options.placeholderImageEnabled &&
          value.options.placeholderImage
        ) {
          formattedValue = getAssetURL(value.options.placeholderImage)
        } else {
          return
        }
      }

      if (Array.isArray(val)) {
        // Map list items
        val = val.map(itm => {
          let childProps = {}

          let getListBinding = listId => {
            if (listId === value.id) {
              return itm
            }

            if (getBinding) {
              return getBinding(listId)
            }
          }

          let refProps = referenceProps[prop.name] || []

          refProps.forEach(prop => {
            let value = values[prop.name]
            let binding

            if (value) {
              binding = value

              value = evaluateBinding(state, value, {
                ...context,
                getBinding: getListBinding,
                listItemId: itm.id,
              })
            }

            childProps[prop.name] = formatLibraryValue(value, prop, binding, {
              ...formatOpts,
              values,
              object,
            })
          })

          let refs = references[prop.name] || []

          refs.forEach(child => {
            let props = {}

            child.props.forEach(prop => {
              let childValues = values[child.name]
              let value = childValues && childValues[prop.name]
              let binding = value

              if (value) {
                value = evaluateBinding(state, value, {
                  ...context,
                  getBinding: getListBinding,
                  listItemId: itm.id,
                })
              }

              props[prop.name] = formatLibraryValue(value, prop, binding, {
                ...formatOpts,
                values: childValues,
                object,
              })

              if (prop.styles) {
                props = deepSet(
                  props,
                  ['styles', prop.name],
                  normalizeStyles(prop, values[child.name], app.branding)
                )
              }
            })

            childProps[child.name] = props
          })

          return {
            ...childProps,
            id: (itm._meta && itm._meta.id) || itm.id,
            _meta: { ...itm._meta, record: itm },
          }
        })

        bindingValues[value.id] = val
      }

      formattedValue = formatLibraryValue(val, prop, value, {
        ...formatOpts,
        values,
        object,
      })
    } else {
      formattedValue = formatLibraryValue(value, prop, null, {
        ...formatOpts,
        values,
        object,
      })
    }

    if (
      !formattedValue &&
      value &&
      value.type === 'imageBinding' &&
      value.options &&
      value.options.placeholderImageEnabled &&
      value.options.placeholderImage
    ) {
      formattedValue = getAssetURL(value.options.placeholderImage)
    }

    if (prop.role === 'formValue') {
      result[prop.name] = {
        value: getValue(state, `${object.id}.${prop.name}`),
        initial: formattedValue,
      }
    } else {
      result[prop.name] = formattedValue
    }
  })

  normalChildComponents.forEach(child => {
    let childValues = values[child.name] || {}
    let childGlobals = libraryGlobals[child.name] || {}

    result[child.name] = {}

    child.props.forEach(prop => {
      let value = prop.global ? childGlobals[prop.name] : childValues[prop.name]
      let binding = null

      if (value) {
        binding = value

        value = evaluateBinding(state, value, { ...context, getBinding })
      }

      if (prop.role === 'formValue') {
        result[child.name][prop.name] = {
          value: getValue(state, `${object.id}.${child.name}.${prop.name}`),
          initial: formatLibraryValue(value, prop, binding, {
            ...formatOpts,
            values: childValues,
            object,
          }),
        }
      } else {
        result[child.name][prop.name] = formatLibraryValue(
          value,
          prop,
          binding,
          {
            ...formatOpts,
            values: childValues,
            object,
          }
        )
      }
    })
  })

  return {
    bindingValues,
    componentProps: result,
  }
}
